export const slider = {
  root: {
    transitionDuration: "{transition.duration}",
  },
  track: {
    background: "{content.border.color}",
    borderRadius: "{content.border.radius}",
    size: "3px",
  },
  range: {
    background: "{primary.default}",
  },
  handle: {
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    background: "{content.border.color}",
    hoverBackground: "{content.border.color}",
    content: {
      borderRadius: "50%",
      hoverBackground: "{content.border.color}",
      width: "16px",
      height: "16px",
      shadow: "0px 0.5px 0px 0px {content.border.color}, 0px 0px 0px 0px {content.border.color}",
    },
    // focusRing: {
    //   width: "{focus.ring.width}",
    //   style: "{focus.ring.style}",
    //   color: "{focus.ring.color}",
    //   offset: "{focus.ring.offset}",
    //   shadow: "{focus.ring.shadow}",
    // },
  },
  colorScheme: {
    light: {
      handle: {
        content: {
          background: "{surface.0}",
        },
      },
    },
    dark: {
      handle: {
        content: {
          background: "{surface.950}",
        },
      },
    },
  },
};
